import { IconButton, IconButtonSize, IconButtonTheme } from '@apply/components';
import { faPencil } from '@fortawesome/free-solid-svg-icons';

interface BorrowerEntityHeaderProps {
    name: string;
    /** Omit to leave out the edit button. */
    onEdit?: () => void;
}

/** The entity's name, with a button to edit its details. */
export const BorrowerEntityHeader = ({ name, onEdit }: BorrowerEntityHeaderProps) => {
    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <b>{name}</b>
            {onEdit && (
                <IconButton
                    id='borrowerEntityEdit'
                    theme={IconButtonTheme.Transparent}
                    size={IconButtonSize.ExtraSmall}
                    icon={faPencil}
                    hint='Edit Borrower Details'
                    handleClick={onEdit}
                />
            )}
        </div>
    );
};
